import React, {KeyboardEvent, MouseEvent, PureComponent, ReactNode} from 'react';
import {KEY_ENTER} from 'app/utils/Consts';
import {isGuest} from 'app/utils';
import {openAuth} from 'app/components/auth/auth';

interface BetSlipLatestBetsProps {
    onClick: (e: MouseEvent<HTMLButtonElement>) => void
    title: string
    disabled?: boolean
    makeBet: () => void
}

export default class BetSlipLatestBet extends PureComponent<BetSlipLatestBetsProps> {
    handleEnter = (event: KeyboardEvent<HTMLButtonElement>): void => {
        if (event.key === KEY_ENTER) {
            event.preventDefault();
            if (isGuest()) {
                openAuth();
                return;
            }
            this.props.makeBet();
        }
    };

    render(): ReactNode {
        const {title, onClick, disabled} = this.props;
        return <button className="button-latest-bet" onClick={onClick} disabled={disabled} onKeyDown={this.handleEnter}>
            {title}
        </button>;
    }
}
